<template>
  <div>
    <validateMatchModal
      :productToEdit="selectedProductToAction"
      :matchesList="matchesList"
      :pagination="pagination"
      :filter="searchParams"
      :show="show_validate_modal"
      :component_name="component_name"
      @show-edit-modal="showEditModal"
      @show-notification="showNotification"
      @callback-function="dataChanged"
    />
    <deleteMatchModal
      :ProductToDelete="selectedProductToAction"
      :show="show_delete_modal"
      :component_name="component_name"
      @callback-function="dataChanged"
    />
    <deleteMatchModalMultiple
      :ProductsToDelete="selectedMatchs"
      :show="show_delete_modal_multiple"
      :component_name="component_name"
      @callback-function="dataChanged"
    />
    <editMatchModalCustom
      :ProductToEdit="selectedProductToAction"
      :show="show_edit_modal"
      :component_name="component_name"
      @confirm-edit="dataChanged"
      @show-notification="showNotification"
      v-if="user_website.id == source_id"
    />
    <editMatchModal
      :ProductToEdit="selectedProductToAction"
      :show="show_edit_modal"
      :component_name="component_name"
      @confirm-edit="dataChanged"
      @show-notification="showNotification"
      v-else
    />
    <exportModal
      :show="export_modal_opend"
      :component_name="component_name"
      @show-redirect-modal="showRedirectModal()"
    />
    <exportRedirectModal :show="show_redirect_modal" />
    <histogramchart
      :selected_product="selectedProductToAction"
      :show="show_histograme_modal"
      :component_name="component_name"
      @show-validate-modal="showValidateModal"
    />

    <div v-if="showGlobalAccurateDataMessage" class="d-flex justify-center">
      <v-alert prominent type="warning" class="w-50" color="error">
        <v-row align="center">
          <v-col class="grow">
            <div class="md-text">
              Please note that the information displayed on your dashboard may not be fully accurate
              yet.
            </div>
            <div class="md-text">
              We are currently validating your websites and will ensure precise data within the next
              24 hours.
            </div>
          </v-col>
          <v-col class="shrink">
            <v-btn class="text-none" outlined @click="hideGlobalAccurateDataMessage">Hide</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <!-- <div v-if="showGlobalAddProductsMessage" class="d-flex justify-center"> -->
    <div v-if="false" class="d-flex justify-center">
      <v-alert prominent type="info" class="w-50">
        <v-row align="center">
          <v-col class="grow">
            <div class="md-text">Start by creating your first product list</div>
            <div class="md-text">You can import products from an xlsx or csv file</div>
          </v-col>
          <v-col class="shrink">
            <router-link to="/importations">
              <v-btn class="text-none" outlined>Add Products</v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <v-row>
      <v-col cols="12">
        <v-card flat :color="isReordering ? '#f9f9f9' : ''" class="rounded-md">
          <div class="mt-2 px-0">
            <v-toolbar flat dense color="transparent" class="px-0">
              <h1 class="text-h4 font-weight-bold grey--text text--darken-3">Pricing Overview</h1>
              <v-spacer></v-spacer>
              <v-btn v-if="isReordering" color="primary" small @click="saveOrder"> Save </v-btn>
              <v-menu v-else offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" class="text-none" outlined>
                    Edit
                    <v-icon small right>mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="py-0">
                  <v-list-item @click="isReordering = true" :disabled="showGlobalStats">
                    <v-list-item-icon>
                      <v-icon small>mdi-drag</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Reorder Charts</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-subheader>View Mode</v-subheader>
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch v-model="showGlobalStats" dense></v-switch>
                    </v-list-item-action>
                    <v-list-item-content
                      @click="showGlobalStats = !showGlobalStats"
                      style="cursor: pointer"
                    >
                      <v-list-item-title>Use Global Stats</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="showConfigModal = true" :disabled="showGlobalStats">
                    <v-list-item-icon>
                      <v-icon small>mdi-view-dashboard-edit</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Manage Charts</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="resetConfig">
                    <v-list-item-icon>
                      <v-icon small>mdi-restore</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Reset config</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </div>
          <v-card-text>
            <!-- <chartcardavailability /> -->
            <GlobalStats
              v-if="showGlobalStats"
              :hide_title="true"
              :filter="filter"
              :component_name="component_name"
              @filter-selected="handleGlobalStatsFilter"
            />
            <draggable
              v-else-if="match_length.list_length"
              v-model="dashboardCards"
              class="row px-1"
              ghost-class="ghost-card"
              drag-class="drag-card"
              :disabled="!isReordering"
              :animation="200"
            >
              <v-col
                :md="columnCols"
                cols="12"
                v-for="card in dashboardCards"
                :key="card.id"
                class="pa-2"
                :class="{ 'draggable-item': isReordering }"
                v-show="card.visible"
              >
                <component
                  :is="card.component"
                  :component_name="component_name"
                  :filter_reset="card.id === 'distribution' ? filter_reset : undefined"
                  @onSelectPriceIndex="
                    card.id === 'distribution' ? filterByPriceIndex($event) : undefined
                  "
                  :ref="card.ref"
                  :cols="columnCols"
                />
              </v-col>
            </draggable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="px-4">
      <v-col cols="12" id="dashboard-container">
        <v-card outlined>
          <v-card-title>
            <span class="md-text">
              <v-switch
                color="error"
                dense
                class="ma-0"
                v-model="compactTable"
                :label="compactTable ? 'Compact View' : 'Basic View'"
                hide-details
              >
              </v-switch
            ></span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  light
                  small
                  color="primary"
                  class="text-none"
                  @click="showExportModal"
                  :disabled="matches_stats"
                  >Prepare your export
                  <v-icon right dark>mdi-database-export</v-icon>
                </v-btn>
                <v-btn
                  :disabled="!selectedMatchs.length || isViewer"
                  outlined
                  light
                  small
                  color="error"
                  class="mr-2 text-none"
                  @click="deleteMatchs"
                  >Delete Products
                  <v-icon right dark>mdi-delete-forever</v-icon>
                </v-btn>
                <router-link to="/importations" class="ml-auto mr-2 text-none">
                  <v-btn
                    v-if="!matches_stats && !isViewer"
                    light
                    color="primary"
                    small
                    class="text-none"
                    @click="deleteMatchs"
                    >Add more products
                    <v-icon right dark>mdi-tag-plus</v-icon>
                  </v-btn>
                </router-link>
              </template>
              <span>export your histories matches data </span>
            </v-tooltip>
          </v-card-title>
          <v-card-text
            v-if="
              showGlobalAddProductsMessage &&
              ((!matches_stats && !match_length.list_length) || matches_stats)
            "
          >
            <div v-if="!matches_stats && !match_length.list_length" class="d-flex justify-center">
              <v-alert prominent type="info" color="secondary" class="w-50">
                <v-row align="center">
                  <v-col class="grow">
                    <div>Your product list will be available soon</div>
                  </v-col>
                </v-row>
              </v-alert>
            </div>
            <!-- <div class="d-flex justify-center" v-if="matches_stats"> -->
            <div class="d-flex justify-center" v-if="false">
              <div class="w-50">
                <v-row align="center">
                  <v-col cols="12">
                    <div class="text-h4 mb-2 text-center">No products yet!</div>
                    <div class="text-center md-text">
                      Create your first product list to get started.
                    </div>
                    <div class="text-center md-text">
                      You can also import products from an XLSX or CSV file.
                    </div>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    <router-link to="/importations">
                      <v-btn class="text-none" color="error">Add Products</v-btn>
                    </router-link>
                  </v-col>
                </v-row>
              </div>
            </div>
            <Importation
              v-if="matches_stats && !isViewer"
              :showRecentImportations="false"
              mainTitle="No Product Yet!"
              subTitle="Start by creating your first product list to get started."
              @onImportSuccess="() => refresh()"
            />
            <div
              v-if="matches_stats && isViewer"
              class="d-flex justify-center align-center flex-column py-10"
            >
              <div class="text-h5 grey--text">No products available</div>
            </div>
            <!--This to validate the match if not validated-->
          </v-card-text>
          <v-card-text v-else>
            <filterInputs
              ref="filterInputs"
              @load-data="dataChanged"
              :component_name="component_name"
            />
            <v-row>
              <v-col cols="12" class="pb-0">
                <simpleComparePricesTable
                  v-if="compactTable"
                  :changed="data_changed"
                  :loading="loading"
                  :selected_price_index="selected_price_index"
                  :component_name="component_name"
                  :filter="filter"
                  @select-matchs="matchsSelected"
                  @show-price-chart="showPriceChart"
                  @show-edit-modal="showEditModal"
                  @show-validate-modal="showValidateModal"
                  @confirm-delete="confirmDelete"
                  @show-notification="showNotification"
                >
                </simpleComparePricesTable>
                <comparePricesTable
                  v-else
                  :changed="data_changed"
                  :loading="loading"
                  :selected_price_index="selected_price_index"
                  :component_name="component_name"
                  :filter="filter"
                  @select-matchs="matchsSelected"
                  @show-price-chart="showPriceChart"
                  @show-edit-modal="showEditModal"
                  @show-validate-modal="showValidateModal"
                  @confirm-delete="confirmDelete"
                  @show-notification="showNotification"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <DashboardConfigModal
      v-model="showConfigModal"
      :cards="dashboardCards"
      :component_name="component_name"
      @save="updateDashboardConfig"
    />
    <snackbar :show="snackbar" :color="snackbar_color" :msg="snackbar_msg" :icon="snackbar_icon" />
  </div>
</template>

<script>
  import axios from 'axios'
  import histogramchart from '../common/histogramChart'
  import chartcarddistribution from '../common/chartCardDistribution'
  import chartcardpriceindex from '../common/charCardPriceIndex'
  import chartcardavailability from '../common/chartCardAvailability.vue'
  import comparePricesTable from '../common/comparePricesTable.vue'
  import simpleComparePricesTable from '../common/simpleComparePricesTable.vue'
  import exportModal from '../Exportation/exportModal.vue'
  import exportRedirectModal from '../common/exportRediretModal.vue'
  import deleteMatchModal from '../common/deleteMatchModal.vue'
  import deleteMatchModalMultiple from '../common/deleteMatchModalMultipl.vue'
  import editMatchModal from '../common/editMatchModal.vue'
  import editMatchModalCustom from '../common/editMatchModalCustom.vue'
  import filterInputs from '../common/filterInputs.vue'
  import validateMatchModal from '../common/validateMatchModal.vue'
  import Importation from '../Importation/Importation.vue'
  import chartcardpricingstatus from '../common/chartPricingStatus'
  import draggable from 'vuedraggable'
  import GlobalStats from '../common/GlobalStats.vue'
  import DashboardConfigModal from './DashboardConfigModal.vue'

  export default {
    name: 'Pricing',
    components: {
      DashboardConfigModal,
      GlobalStats,
      draggable,
      chartcardpricingstatus,
      chartcardavailability,
      Importation,
      exportModal,
      exportRedirectModal,
      histogramchart,
      chartcarddistribution,
      chartcardpriceindex,
      comparePricesTable,
      simpleComparePricesTable,
      deleteMatchModal,
      deleteMatchModalMultiple,
      editMatchModal,
      editMatchModalCustom,
      filterInputs,
      validateMatchModal,
    },
    props: {},
    data() {
      return {
        compactTable: true,
        source_id: '6019aee744817b0f85ff85bb',
        match_length: { list_length: 1 },
        show_redirect_modal: false,
        snackbar: false,
        snackbar_color: '',
        snackbar_msg: '',
        snackbar_icon: '',
        loading: false,
        filter: {},
        filter_reset: false,
        isReordering: false,
        showConfigModal: false,
        showGlobalStats: false,
        dashboardCards: [
          {
            id: 'priceIndex',
            component: 'chartcardpriceindex',
            ref: 'priceIndexChart',
            title: 'Price Index',
            visible: true,
          },
          {
            id: 'distribution',
            component: 'chartcarddistribution',
            ref: 'distributionChart',
            title: 'Distribution',
            visible: true,
          },
          {
            id: 'pricingStatus',
            component: 'chartcardpricingstatus',
            ref: 'pricingStatusChart',
            title: 'Pricing Status',
            visible: true,
          },
          {
            id: 'availability',
            component: 'chartcardavailability',
            ref: 'availabilityChart',
            title: 'Availability',
            visible: false,
          },
        ],
        chartData: {
          data: {
            labels: [],
            datasets: [],
          },
        },
        user_website: localStorage.user_website ? JSON.parse(localStorage.user_website) : {},
        account_id: localStorage.getItem('account_id'),
        search: '',
        matchs: [],
        allProducts: [],
        selectedProduct: {},
        selectedProductToAction: {
          match_id: '',
          match_ref: '',
          product_brand: '',
          product_name: '',
          product_image: '',
        },
        showProductChart: false,
        websites: {},
        matches_stats: false,
        showGlobalAddProductsMessage: false,
        showGlobalAccurateDataMessage: false,
        export_modal_opend: false,
        // lastAvailableDate: 0,
        show_histograme_modal: false,
        show_delete_modal: false,
        show_delete_modal_multiple: false,
        show_edit_modal: false,
        show_validate_modal: false,
        total_data: 0,
        data_changed: false,
        selected_price_index: null,
        component_name: this.$router.history.current.fullPath,
        selectedMatchs: [],
        matchesList: [],
        pagination: {},
        searchParams: {},
      }
    },
    computed: {
      isViewer() {
        return this.$store.getters.userRole === 'viewer'
      },
      visibleCardsCount() {
        return this.dashboardCards.filter((c) => c.visible).length
      },
      columnCols() {
        const count = this.visibleCardsCount
        if (count <= 1) return 12
        if (count === 2) return 6
        if (count === 3) return 4
        return 3
      },
    },
    methods: {
      handleGlobalStatsFilter(value) {
        if (this.$refs.filterInputs) {
          const currentMatched = this.filter.matched || ''
          const newValue = currentMatched === value && value !== '' ? '' : value
          this.$refs.filterInputs.setMatchedFilter(newValue)
        }
      },
      updateDashboardConfig(newCards) {
        this.dashboardCards = newCards
        this.saveOrder()
      },
      resetConfig() {
        this.showGlobalStats = false
        this.isReordering = false
        this.dashboardCards = [
          {
            id: 'priceIndex',
            component: 'chartcardpriceindex',
            ref: 'priceIndexChart',
            title: 'Price Index',
            visible: true,
          },
          {
            id: 'distribution',
            component: 'chartcarddistribution',
            ref: 'distributionChart',
            title: 'Distribution',
            visible: true,
          },
          {
            id: 'pricingStatus',
            component: 'chartcardpricingstatus',
            ref: 'pricingStatusChart',
            title: 'Pricing Status',
            visible: true,
          },
          {
            id: 'availability',
            component: 'chartcardavailability',
            ref: 'availabilityChart',
            title: 'Availability',
            visible: false,
          },
        ]
        localStorage.removeItem('dashboardCardsOrder')
      },
      showExportModal() {
        this.export_modal_opend = !this.export_modal_opend
      },
      saveOrder() {
        this.isReordering = false
        localStorage.setItem('dashboardCardsOrder', JSON.stringify(this.dashboardCards))
      },
      loadOrder() {
        const savedOrder = localStorage.getItem('dashboardCardsOrder')
        if (savedOrder) {
          try {
            const parsed = JSON.parse(savedOrder)
            this.dashboardCards = parsed.map((card) => {
              let title = card.title
              if (!title) {
                if (card.id === 'priceIndex') title = 'Price Index'
                else if (card.id === 'distribution') title = 'Distribution'
                else if (card.id === 'pricingStatus') title = 'Pricing Status'
                else if (card.id === 'availability') title = 'Availability'
              }
              return {
                ...card,
                visible: card.visible !== undefined ? card.visible : true,
                title: title,
              }
            })
          } catch (e) {
            console.error('Error parsing saved dashboard order', e)
          }
        }
      },
      dataChanged(payload) {
        if (payload && payload.reset) {
          this.filter_reset = new Date().getTime()
          //remove price index filter
          this.selected_price_index = null
        }
        this.filter = payload
        this.data_changed = !this.data_changed
        this.selectedMatchs = []
        this.getMatchsStat()
        if (this.$refs.priceIndexChart && this.$refs.priceIndexChart[0]) {
          this.$refs.priceIndexChart[0].initHistoryChart()
        }
        if (this.$refs.distributionChart && this.$refs.distributionChart[0]) {
          this.$refs.distributionChart[0].update()
        }
        if (this.$refs.pricingStatusChart && this.$refs.pricingStatusChart[0]) {
          this.$refs.pricingStatusChart[0].update()
        }
      },

      showRedirectModal() {
        this.show_redirect_modal = !this.show_redirect_modal
      },
      filterByPriceIndex(payload) {
        document.querySelector('#dashboard-container').scrollIntoView()
        this.selected_price_index = payload
      },
      deleteMatchs() {
        if (this.isViewer) return
        this.show_delete_modal_multiple = !this.show_delete_modal_multiple
      },
      async setUserWebsites() {
        await axios
          .get('/api/websites/list', {
            params: {
              account: this.account_id,
              user: localStorage.getItem('user_id'),
              component: this.component_name,
            },
          })
          .then((res) => {
            localStorage.setItem(`user_website`, JSON.stringify(res.data.account.website))
            localStorage.setItem(`user_websites`, JSON.stringify(res.data.account.websites))
            this.selectedMatchs = []
          })
      },
      hideGlobalAccurateDataMessage() {
        localStorage.setItem('show_ACCURATEDATA_MESSAGE', 'hide')
        this.showGlobalAccurateDataMessage = false
      },
      hideAddProductsMessage() {
        localStorage.setItem('show_PRODUCTS_MESSAGE', 'hide')

        if (this.matches_stats && localStorage.getItem('show_PRODUCTS_MESSAGE') === 'show') {
          this.showGlobalAddProductsMessage = true
        } else {
          this.showGlobalAddProductsMessage = false
        }
      },
      matchsSelected(matchs) {
        this.selectedMatchs = matchs
      },
      confirmDelete(item) {
        if (this.isViewer) return
        this.selectedProductToAction = item
        this.show_delete_modal = !this.show_delete_modal
      },
      showEditModal(item) {
        if (this.isViewer) return
        this.selectedProductToAction = item
        this.show_edit_modal = !this.show_edit_modal
      },
      showValidateModal(item) {
        if (this.isViewer) return
        this.selectedProductToAction = item.item
        this.matchesList = item.data
        this.pagination = item.pagination
        this.searchParams = item.searchParams
        this.show_validate_modal = !this.show_validate_modal
      },
      showPriceChart(item) {
        this.selectedProductToAction = item
        this.show_histograme_modal = !this.show_histograme_modal
      },
      showNotification(payload) {
        this.snackbar_color = payload.type
        this.snackbar_msg = payload.msg
        this.snackbar = !this.snackbar
        this.snackbar_icon = payload.icon
      },
      async getMatchsStat() {
        this.match_length = await axios
          .get('/api/products/matchsstat', {
            params: {
              account: this.account_id,
              user: localStorage.getItem('user_id'),
              component: this.component_name,
            },
          })
          .then((res) => {
            return res.data
          })
        if (this.match_length.data_length) this.matches_stats = false
        else this.matches_stats = true

        if (this.matches_stats && localStorage.getItem('show_PRODUCTS_MESSAGE') === 'show') {
          this.showGlobalAddProductsMessage = true
        } else {
          this.showGlobalAddProductsMessage = false
        }

        if (
          this.matches_stats &&
          !this.match_length.list_length &&
          localStorage.getItem('show_ACCURATEDATA_MESSAGE') !== 'hide'
        ) {
          localStorage.setItem('show_ACCURATEDATA_MESSAGE', 'show')
          this.showGlobalAccurateDataMessage = true
        }

        if (
          localStorage.getItem('show_ACCURATEDATA_MESSAGE') == 'show' &&
          this.showGlobalAccurateDataMessage == false
        ) {
          this.showGlobalAccurateDataMessage = true
        } else {
          this.showGlobalAccurateDataMessage = false
        }
      },
      refresh() {
        this.setUserWebsites()
        this.getMatchsStat()
      },
    },
    created() {
      if (localStorage.getItem('compactTable') == 'true') {
        this.compactTable = true
      } else if (localStorage.getItem('compactTable') == 'false') {
        this.compactTable = false
      } else {
        this.compactTable = true
      }
      this.showGlobalStats = localStorage.getItem('pricing_showGlobalStats') === 'true'
    },
    mounted() {
      this.loadOrder()
      this.refresh()
    },
    watch: {
      showGlobalStats(val) {
        localStorage.setItem('pricing_showGlobalStats', val)
      },
      compactTable(val) {
        localStorage.setItem('compactTable', val)
      },
    },
  }
</script>

<style scoped>
  .product-image {
    max-height: 70px;
    background-size: cover;
  }
  .theme--light.v-application {
    background: none !important;
  }

  .more-info {
    cursor: pointer;
  }

  .draggable-item {
    cursor: -webkit-grab;
    cursor: grab;
  }
  .draggable-item:active {
    cursor: -webkit-grabbing;
    cursor: grabbing;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    z-index: 10;
  }

  .ghost-card {
    opacity: 0.5;
    background: #f7f7f7;
  }

  .drag-card {
    opacity: 1 !important;
    background: #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
  }
</style>
